import {CellContent, TableConfig, TCTypeEnum, FilterRoleEnum} from 'ngx-satoris';

export enum TablePlacesEnum {
  ID = 'placeId',
  NAME = 'name'
}

export enum TablePlacesFilterEnum {
  ID = 'placeId',
  NAME = 'name'
}

export const TABLE_PLACES_CONFIG: TableConfig = {
  tableId: 'table-places',
  version: '1.0.1',
  rowsClickable: true,
  useFilterCheckbox: true,
  pagination: {
    serverPagination: true,
    itemsPerPage: [5, 10, 15, 20, 30, 50],
    activeItemsPerPage: 20,
    enablePageDataCaching: true,
    preloadPages: 1
  },
  rowsExpandable: {
    active: false
  },
  menusDisplay: {
    isFilterPanelCollapsed: false,
    isColumnPanelCollapsed: true
  },
  table: {
    [TablePlacesEnum.ID]: {
      visible: true,
      value: 'placeId',
      sortable: false,
      serverSorting: true,
      filterable: true,
      truncateMaxLength: 30,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.TEXT,
        role: FilterRoleEnum.SINGLE,
        rowIndex: 1,
        serverFilter: true,
        filterId: TablePlacesFilterEnum.ID,
        validators: {
          minLength: 2,
          maxLength: 50
        }
      }]
    },
    [TablePlacesEnum.NAME]: {
      visible: true,
      value: 'name',
      sortable: false,
      serverSorting: true,
      filterable: true,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.TEXT,
        role: FilterRoleEnum.SINGLE,
        rowIndex: 2,
        serverFilter: true,
        filterId: TablePlacesFilterEnum.NAME,
        validators: {
          minLength: 2,
          maxLength: 50
        }
      }]
    }
  }
};

export const ORIGINAL_TABLE_PLACES_CONFIG: TableConfig = JSON.parse(JSON.stringify(TABLE_PLACES_CONFIG));
